var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.elements),function(element){return _c('span',{key:element.label},[_c('data-row',{attrs:{"element":element}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }